import React, { useCallback, useEffect, useState } from 'react'
import classNames from 'classnames'

import { useModalDrivers } from 'mednet-cns/src/hooks/modal'

import { RECIPIENTS_MODAL } from 'mednet-util/src/constants/modal'

import { Modal } from 'pharmacy/src/display/modal'
import { Button } from 'pharmacy/src/input/button'
import { Header4, Label1 } from 'pharmacy/src/typography'
import TextInput from 'pharmacy/src/input/textInput/textInput'
import CenteredContent from 'pharmacy/src/display/content/centeredContent'

import { UserSearch } from 'pages/userSearch'

import * as css from './recipientsModal.scss'
import * as campaignCSS from './campaign.scss'

const MainScreen = ({
  onAdd,
  onSave,
  recipients,
  id,
  queryUserStatus,
  isDisabled,
}) => {
  const isEdit = Boolean(recipients)
  const defaultFilterUsersWithoutRecentActivity =
    queryUserStatus === 'active' ? 'RESTRICTED_VENDORS' : 'NONE'

  const [recipientsQuery, setRecipientsQuery] = useState({
    tree: recipients?.tree,
    isFileImport: recipients?.isFileImport,
    file: recipients?.file,
    filterUsersWithoutRecentActivity:
      recipients?.filterUsersWithoutRecentActivity ||
      defaultFilterUsersWithoutRecentActivity,
  })

  const [name, setName] = useState(recipients?.name)
  const [selectedRecipients, setSelectedRecipients] = useState(
    recipients?.selected || {}
  )

  useEffect(() => {
    if (recipients) {
      setSelectedRecipients(recipients?.selected)
      setRecipientsQuery({
        tree: recipients?.tree,
        isFileImport: recipients?.isFileImport,
        file: recipients?.file,
        filterUsersWithoutRecentActivity:
          recipients?.filterUsersWithoutRecentActivity ||
          defaultFilterUsersWithoutRecentActivity,
      })
    }
  }, [recipients])

  useEffect(() => {
    if (recipientsQuery?.tree?.name && !name) {
      setName(recipientsQuery?.tree.name)
    }
  }, [recipientsQuery?.tree?.name])

  // eslint-disable-next-line no-unused-vars
  const [_openRecipientsModal, closeRecipientsModal] = useModalDrivers(
    RECIPIENTS_MODAL.modalId
  )

  const handleAdd = useCallback(() => {
    onAdd && onAdd({ ...recipientsQuery, name, selected: selectedRecipients })
    closeRecipientsModal()
  }, [onAdd, name, selectedRecipients, recipientsQuery])

  const handleSave = useCallback(() => {
    onSave &&
      onSave({ ...recipientsQuery, id, name, selected: selectedRecipients })
    closeRecipientsModal()
  }, [onSave, name, selectedRecipients, recipientsQuery])

  const recipientsAdjective =
    queryUserStatus === 'unregistered' ? 'unregistered' : 'active'

  return (
    <CenteredContent size="xlarge">
      <div className={css.contents}>
        <Header4>
          {isEdit
            ? `Edit ${recipientsAdjective} recipients`
            : `Add ${recipientsAdjective} recipients`}
        </Header4>
        <div className={css.headerBar}>
          <div className={css.name}>
            <Label1>
              Recipients group name:
              <TextInput
                className={classNames(campaignCSS.input, css.recipientsName)}
                onChange={setName}
                value={name}
                disabled={isDisabled}
              ></TextInput>
            </Label1>
          </div>
          <div className={css.actions}>
            <Button
              isDisabled={!Object.keys(selectedRecipients).length || isDisabled}
              icon={isEdit ? 'check' : 'plus'}
              onClick={isEdit ? handleSave : handleAdd}
            >
              {isEdit ? 'Save' : 'Add'}
            </Button>
          </div>
        </div>
        <UserSearch
          selectable
          queryUserStatus={queryUserStatus}
          activeTab={isEdit ? (recipients?.isFileImport ? 2 : 1) : 0}
          filePath={recipients?.filePath}
          fileDownloadUrl={recipients?.fileDownloadUrl}
          initialSearchQuery={recipientsQuery}
          onSearch={setRecipientsQuery}
          selectedUsers={selectedRecipients}
          setSelectedUsers={setSelectedRecipients}
        />
      </div>
    </CenteredContent>
  )
}

const screens = {
  [RECIPIENTS_MODAL.screens.main]: MainScreen,
}

export const RecipientsModal = React.memo((props) => {
  return (
    <Modal
      closeOnBackdrop
      modalId={RECIPIENTS_MODAL.modalId}
      screens={screens}
      defaultScreen={RECIPIENTS_MODAL.screens.main}
      size="fullscreen"
      {...props}
    ></Modal>
  )
})
RecipientsModal.displayName = 'RecipientsModal'
